import * as React from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

import { Link, useNavigate, useParams } from 'react-router-dom';

import AuthLayout, { TRUE_DARK, primaryButtonSx } from './auth/AuthLayout';

const baseUrl = process.env.REACT_APP_BASE_URL;

const Validating = () => {
    const navigate = useNavigate();

    const { uid, token } = useParams<{ uid: string, token: string}>();
    const [failed, setFailed] = React.useState(false);

    React.useEffect(() => {
        const verify = async () => {
            try {
                const response = await fetch(`${baseUrl}/management/activate-account/${uid}/${token}/`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                if (response.ok) {
                    navigate('/verification-success', { replace: true });
                    return;
                }
            } catch (error) {
                console.log(error);
            }
            setFailed(true);
        }
        verify();
    }, [navigate, token, uid]);

    if (failed) {
        return (
            <AuthLayout title="Enlace inválido" subtitle="El enlace de verificación es inválido o ya expiró.">
                <Button component={Link} to="/login" fullWidth variant="contained" sx={primaryButtonSx}>
                    Ir a iniciar sesión
                </Button>
            </AuthLayout>
        );
    }

    return (
        <AuthLayout title="Verificando tu cuenta" subtitle="Esto tomará solo un momento.">
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
                <CircularProgress sx={{ color: TRUE_DARK }} />
            </Box>
        </AuthLayout>
    );
};

export default Validating;
